import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export const MetaPixel: React.FC = () => {
  useEffect(() => {
    const pixelId = '1252242806993118';
    // Avoid double-initialization (StrictMode runs effects twice in dev)
    if (window.fbq) {
      try {
        window.fbq('track', 'PageView');
      } catch (e) {
        // no-op
      }
      return;
    }
    // Initialize the fbq stub safely without relying on existing <script> tags
    const fbq: any = function () {
      // eslint-disable-next-line prefer-rest-params
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    // Inject the Facebook events script directly into <head>
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    // Queue the init + PageView — they will run once the script loads
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-118">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1252242806993118&ev=PageView&noscript=1" alt="" data-id="element-119" />
    </noscript>;
};